<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		selection
		paging
		:pageUnit="groups.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="groups.totalSize"
		:currentPage="groups.currentPage"
		@changedPage="changedPage"
		@select="onSelect"
		@select-all="onSelectAll"
	>
	</sf-data-table>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ControlManagement/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		columns() {
			return [
				{
					label: this.getMessage_('SWCC000320'), //화면Id
					prop: 'scrId',
					minWidth: '60px'
				},
				{
					label: this.getMessage_('SWCC000321'), //화면명
					prop: 'scrName',
					minWidth: '140px'
				},
				{
					label: this.getMessage_('SWCC000217'), //사용자ID
					prop: 'userId',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000218'), //사용자 이름
					prop: 'userName',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000781'), //제어권 획득 시간
					prop: 'stime',
					minWidth: '120px'
				},
				{
					label: this.getMessage_('SWCC000782'), //제어권 반환 시간
					prop: 'etime',
					minWidth: '120px'
				},
				{
					label: this.getMessage_('SWCC000783'), //수정자 ID
					prop: 'chgId',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000784'), //사용자 로그인 상태
					prop: 'loginStat',
					minWidth: '80px'
				}
			];
		},
		rows() {
			return this.groups.data;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.$sf_toggleLoading(true);
			// plantCd: this.plantCd,
			// 	scrId: this.scrId,
			// 	scrName: this.scrName,
			// 	userId: this.userId,
			// 	onlyIng: this.onlyIng,
			// 	currentPage: 1,
			// 	pageUnit: this.groups.pageUnit
			this.getControlList_({
				plantCd: this.searchParams.plantCd,
				scrId: this.searchParams.controlScrId,
				scrName: this.searchParams.controlScrName,
				userId: this.searchParams.userId,
				onlyIng: this.searchParams.onlyIng,
				currentPage: currentPageVal,
				pageUnit: pageUnitVal
			})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		clickControl(row) {
			// console.log(row);
			// this.setModalValues_({ key: 'flg', value: 'U' });
			// this.setModalValues_({ key: 'groupCode', value: row.groupCode });
			// this.setModalValues_({ key: 'deviceId', value: row.deviceId });
			// this.setModalValues_({ key: 'deviceNm', value: row.deviceNm });
			// this.setModalValues_({ key: 'deviceTbNm', value: row.deviceTbNm });
			// this.setModalValues_({ key: 'deviceTbDesc', value: row.deviceTbDesc });
			// this.setModalValues_({ key: 'dispYn', value: row.dispYn });
			// //this.setModalValues_({ params: row, flg: 'U' });
			// this.getMachineList_({ plantCd: this.plantCd, deviceId: row.deviceId })
			// 	.then(() => {
			// 		this.defaultAssign_({ key: 'ControlManagementModal', value: true });
			// 	})
			// 	.catch(error => {
			// 		this.$sf_toast({ type: 'error', message: error.message });
			// 	})
			// 	.finally(() => {
			// 		this.$sf_toggleLoading(false);
			// 	});
		},

		/*
		 * table checkbox에서 radio button 처럼 하나만 체크되도록 해야될 경우 처리함수
		 */
		onSelect(selection) {
			this.defaultAssign_({
				key: 'selection',
				value: selection
			});
		},

		onSelectAll(selection) {
			this.defaultAssign_({
				key: 'selection',
				value: selection
			});
		}
	}
};
</script>
<style></style>
